import { ResidenceModel } from '../models/residence-model';
import { AddressModel } from '../models/address-model';

export class AddressFormService {

  private form: ResidenceModel;

  personalAddressProspect = new AddressModel();

  constructor() {
    this.form = new ResidenceModel();
  }

  getForm() {
    return this.form;
  }

  setForm(form: ResidenceModel) {
    this.form = form;
  }

  getProperty(property: any) {
    return this.form[property];
  }

  setProperty(property: string, value: any) {
    this.form[property] = value;
  }
}
